import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51402340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "area-jobItem" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "explain-text" }, "登録に失敗した資料があります。再度送信していただくかお問い合わせください。", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title jobItem-title" }, "登録失敗した資料", -1))
const _hoisted_6 = { class: "table errorItem" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"6%"},
      class: "number"
    }, "No."),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"14%"},
      class: "itemId"
    }, "アイテムID"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"20%"},
      class: "fileName"
    }, "ファイル名"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"6%"},
      class: "row"
    }, "行"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"54%"},
      class: "errorText"
    }, "エラー内容")
  ])
], -1))
const _hoisted_8 = { class: "number" }
const _hoisted_9 = { class: "itemId" }
const _hoisted_10 = { class: "fileName" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "errorText" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title jobItem-title" }, "登録成功した資料", -1))
const _hoisted_15 = { class: "object-item-table successItem" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "detail" }
const _hoisted_18 = { class: "area-title" }
const _hoisted_19 = ["onClick", "onKeydown"]
const _hoisted_20 = { class: "object-title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label success" }, " 登録成功 ", -1))
const _hoisted_22 = { class: "properties" }
const _hoisted_23 = { class: "property-list" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "永続的識別子", -1))
const _hoisted_25 = { class: "property-pid" }
const _hoisted_26 = { class: "property-list" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "収集", -1))
const _hoisted_28 = { class: "property-collectionDate" }
const _hoisted_29 = { class: "property-list" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "著者", -1))
const _hoisted_31 = { class: "property-author" }
const _hoisted_32 = { class: "property-list" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "提供機関", -1))
const _hoisted_34 = { class: "property-provider" }
const _hoisted_35 = { class: "property-list" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "閲覧できる場所", -1))
const _hoisted_37 = { class: "property-permission" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.props.jobItem?.errorItem.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.jobItem?.errorItem, (data, index) => {
                return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(data.itemId), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(data.fileName), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(data.row), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(data.message), 1)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.props.jobItem?.successItem.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.jobItem?.successItem, (data, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "object-item",
                  key: index
                }, [
                  (data.thumbnailValue)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: `data:image/jpeg;base64,${data.thumbnailValue}`,
                        class: "item-thumbnail",
                        alt: "サムネイル"
                      }, null, 8, _hoisted_16))
                    : (_openBlock(), _createBlock(_component_DssIcon, {
                        key: 1,
                        icon: 'document-book',
                        size: 'is-large'
                      })),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.toItem(data.pid)),
                        onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.toItem(data.pid)), ["prevent"]), ["space","enter"]),
                        class: "button-toItem"
                      }, [
                        _createElementVNode("a", _hoisted_20, _toDisplayString(data.title), 1)
                      ], 40, _hoisted_19),
                      _hoisted_21
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("dl", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("dd", _hoisted_25, _toDisplayString(data.pid), 1)
                      ]),
                      _createElementVNode("dl", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("dd", _hoisted_28, _toDisplayString(_ctx.convertJtc(data.collectionDate)), 1)
                      ]),
                      _createElementVNode("dl", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("dd", _hoisted_31, _toDisplayString(data.author), 1)
                      ]),
                      _createElementVNode("dl", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("dd", _hoisted_34, _toDisplayString(data.provider), 1)
                      ]),
                      _createElementVNode("dl", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("dd", _hoisted_37, _toDisplayString(_ctx.convertPermission(data.permission)), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}